module.exports = __webpack_public_path__ + "static/media/evacuation-emergency.100c21d2.svg";